import { StyleSheet, ViewStyle } from 'react-native';
import { Colors } from './colors';

export const SharedUnvalidatedStyles = {
  borderRadius: {
    borderRadius: 10,
  },
  shadow: {
    boxShadow: '2px 2px 10px rgba(0,0,0,0.2)',
  },
};

export const SharedStyles = StyleSheet.create({
  fill: {
    flex: 1,
    alignSelf: 'stretch',
  },
  full: {
    width: '100%',
    height: '100%',
  },
  centerChildren: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  backdrop: {
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  absoluteCover: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  topRight: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  bottomRight: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  topLeft: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  bottomLeft: {
    position: 'absolute',
    bottom: 0,
    left: 0,
  },
  dashedBorder: {
    borderStyle: 'dashed',
    borderWidth: 1,
    borderColor: Colors.gray.border,
  },
  shadow: SharedUnvalidatedStyles.shadow as ViewStyle,
  borderRadius: SharedUnvalidatedStyles.borderRadius,
});
